import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, CopyOutlined, FileTextOutlined } from '@ant-design/icons';

// Two-column layout header: Verified (we inspected the car) or Dealer documents, VIN with Copy, make and model, numbers
export const Hero = ({ hero }) => {
    const { t } = useTranslation('reportPage');
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;
        try {
            await navigator.clipboard.writeText(hero.vin);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy VIN:', error);
        }
    };

    return (
        <section id="vehicle" className="hero" aria-labelledby="vehicle-title">
            <div className="hero-top">
                {hero.badge === 'verified' ? (
                    <span className="hero-badge verified">
                        <CheckOutlined aria-hidden="true" />
                        {t('layout.verified')}
                    </span>
                ) : (
                    <span className="hero-badge dealer">
                        <FileTextOutlined aria-hidden="true" />
                        {t('layout.dealerDocuments')}
                    </span>
                )}
                <span className="hero-vin mono">{hero.vin}</span>
                <button type="button" className="hero-copy noprint" onClick={copy}>
                    {copied ? <CheckOutlined aria-hidden="true" /> : <CopyOutlined aria-hidden="true" />}
                    {copied ? t('layout.copied') : t('layout.copyVin')}
                </button>
            </div>
            <h1 id="vehicle-title" className="hero-title">
                {hero.brand}
                {hero.model && <span className="hero-model"> {hero.model}</span>}
                {hero.version && <span className="hero-version">{hero.version}</span>}
            </h1>
            {hero.stats.length > 0 && (
                <dl className="hero-stats">
                    {hero.stats.map(stat => (
                        <div key={stat.label}>
                            <dt>{stat.label}</dt>
                            <dd>{stat.value}</dd>
                        </div>
                    ))}
                </dl>
            )}
        </section>
    );
};
